export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20abstract%20product%20photography%20flat%20lay%20with%20scattered%20fashion%20accessories%20on%20a%20warm%20gradient%20background%20from%20peach%20to%20cream%2C%20gentle%20natural%20daylight%2C%20clean%20editorial%20aesthetic%2C%20various%20textures%20of%20leather%20and%20fabric%2C%20no%20text%20or%20logos&width=1600&height=900&seq=hero-new-bg-2026&orientation=landscape"
          alt="VigorBuy Spreadsheet product directory background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 py-24 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          The #1 VigorBuy Spreadsheet<br />Directory in 2026
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-[650px] mx-auto mb-4 leading-relaxed">
          Discover the latest VigorBuy Spreadsheet with verified products, trusted sellers, quality checks, shipping guides, and buying resources.
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-[600px] mx-auto mb-10 leading-relaxed">
          Access thousands of hand-picked products, detailed QC information, seller comparisons, and complete buying guides designed for safer and smarter shopping.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg"
          >
            VigorBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg"
          >
            Buy It Now
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {['✓ Updated Daily', '✓ Verified Sellers', '✓ QC Photos Included', '✓ Shipping Guides', '✓ Safe Buying Tips'].map((badge) => (
            <span key={badge} className="text-xs md:text-sm text-white/70 whitespace-nowrap">
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}